import { PricingConfig } from "./types";

export const PRICING_CONFIG: PricingConfig = {
  title: "Simple, honest pricing",
  subtitle: "Start with Starter. Upgrade when you need more.",
  earlyAdopterNote: "Early adopter offer — keep the £29 rate forever",
  plans: [
    {
      id: "starter",
      name: "Starter",
      price: 29,
      period: "/month",
      description:
        "Everything a UK SME owner needs to know what is safe to spend.",
      badge: {
        text: "Most popular",
        variant: "popular",
      },
      cta: {
        label: "Start free trial",
        href: "/signup",
        variant: "primary",
        subtext: "Cancel anytime",
      },
      trialText: "14-day free trial • No card required",
      features: [
        {
          id: "unlimited-accounts",
          label: "Connect unlimited UK bank accounts via Open Banking",
        },
        {
          id: "csv-upload",
          label: "CSV upload for unsupported banks",
        },
        {
          id: "vat-detection",
          label: "Automatic VAT detection from transactions",
        },
        {
          id: "daily-dashboard",
          label: "Safe-to-Spend dashboard updated daily",
        },
        {
          id: "friday-sms",
          label: "Friday SMS Safe-to-Spend alert",
        },
        {
          id: "reserve-tracking",
          label: "Reserve account tracking",
        },
        {
          id: "confidence-engine",
          label: "Confidence engine — cash, VAT, and reserve",
        },
        {
          id: "audit-trail",
          label: "Full calculation proof and audit trail",
        },
        {
          id: "categorisation",
          label: "Transaction categorisation",
        },
        {
          id: "email-support",
          label: "Email support",
        },
        {
          id: "cancel-anytime",
          label: "Cancel anytime",
        },
      ],
    },
    {
      id: "professional",
      name: "Professional",
      price: 49,
      period: "/month",
      description:
        "For growing SMEs that need integrations, imports, and faster support.",
      badge: {
        text: "Coming Q3 2026",
        variant: "coming-soon",
      },
      cta: {
        label: "Join waitlist",
        href: "#",
        variant: "secondary",
        subtext: "Be first to know",
      },
      features: [
        {
          id: "everything-starter",
          label: "Everything in Starter",
        },
        {
          id: "xero-sync",
          label: "Xero and QuickBooks sync",
        },
        {
          id: "stripe-paypal",
          label: "Stripe and PayPal import",
        },
        {
          id: "card-import",
          label: "Card transaction import",
        },
        {
          id: "whatsapp-messages",
          label: "Friday WhatsApp messages",
        },
        {
          id: "inbound-whatsapp",
          label: "Inbound WhatsApp queries",
        },
        {
          id: "daily-updates",
          label: "Daily Safe-to-Spend updates",
        },
        {
          id: "confidence-history",
          label: "Confidence history",
        },
        {
          id: "multi-account",
          label: "Multi-account support",
        },
        {
          id: "priority-email",
          label: "Priority email support",
        },
      ],
    },
    {
      id: "accountant",
      name: "Accountant",
      price: 199,
      period: "/month",
      description: "For accountants managing multiple clients.",
      badge: {
        text: "Coming Q3 2026",
        variant: "coming-soon",
      },
      cta: {
        label: "Join waitlist",
        href: "#",
        variant: "secondary",
        subtext: "Be first to know",
      },
      features: [
        {
          id: "everything-professional",
          label: "Everything in Professional",
        },
        {
          id: "client-orgs",
          label: "Up to 20 client organisations",
        },
        {
          id: "partner-dashboard",
          label: "Partner dashboard",
        },
        {
          id: "bulk-csv",
          label: "Bulk CSV import",
        },
        {
          id: "client-overview",
          label: "Client-level overview",
        },
        {
          id: "vat-health-report",
          label: "Monthly VAT Cash Health Report",
        },
        {
          id: "referral-commission",
          label: "Accountant referral commission (10%)",
        },
        {
          id: "phone-support",
          label: "Priority phone support",
        },
        {
          id: "early-access",
          label: "Early access to new features",
        },
      ],
    },
  ],
};
